import Routes from 'routes'
import SearchIndex from 'vue_features/search/components/SearchIndex'
const routes = [{ path: Routes.search_path(), component: SearchIndex }]
export default routes
